<template>
  <div class="widget-container" v-html="series">
  </div>
</template>


<script>
export default {
  props: {
    series: {
      type: String,
      required: true,
    },
  },
  computed: {
  },
  data: function () {
    return {
    };
  },
  watch: {
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
@import "./static/css/_variables.scss";
.widget-container {
  width: auto;
  height: auto;
  // Availability tables can be wider than their grid cell (Time + N days);
  // scroll horizontally instead of overflowing the dashboard grid.
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// RawWidget.vue?47b10bca